import axios from "axios";

// export const baseUrl=`http://localhost:6074/`;
export const baseUrl=`/`;
// export const baseUrl=`https://mate.rashigames.com/`;

export const getGamesApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/games`);
    return response;
}

export const loginApi = async (msisdn) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, {
        msisdn: msisdn
    });
    return response;
};

const Integrated_API_URL = "https://api-mslgamesdal.rashigames.com/";

export const SendOtpAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/SendOTP`, {
        msisdn
    });
    return response;
}

export const VerifyOtpAPI = async (msisdn, otp,otp_ref,ext_ref) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp_ref,
        otp,
        ext_ref
    });
    return response;
}

export const SubscriptionLogsApi=async(msisdn)=>{
     const response = await axios.post(`${Integrated_API_URL}subscription-logs`, {
        msisdn,
    });
    return response;
}

export const unsubscribeAPI=async(msisdn)=>{
    const response=await axios.post(`${Integrated_API_URL}deactivate-user`,{msisdn});
    return response;
}